module.exports = __webpack_public_path__ + "img/selected_icon.e222c30f.svg";